import '../styles/404.css'
import {useNavigate} from 'react-router-dom';
const Lost = () => {
    const navigate = useNavigate();
    return ( 
        <div className="main_lost">
            <p className="logo">Viralclicks<span>-mine</span></p>
            <h1>Are you lost?</h1>
            <img src="404.png" alt="" />
            <p>Looks like this page doesn't exist or you are not permited to view it.</p>
            <button onClick={()=>navigate('/')}>Go back home</button>
        </div>
     );
}
 
export default Lost;